import React, { forwardRef } from "react";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import OuterClickListener from "@components/outer-click-listener";
import Icon from "@components/icon";

import AllServices from "../../../AllServices";

import sendMetric from "../../../../utils/sendMetric";

import { useStore } from "../../../../connect";

import strings from "../../../../locales/strings";

import styles from "./AllServicesButton.scss";

const cx = classnames.bind(styles);

const dropdownId = "all-services";

const AllServicesButton = forwardRef((props, ref) => {
  const { header } = useStore();

  const isDropdownActive = header.openedDropdown === dropdownId;

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    header.toggleDropdown(dropdownId);

    sendMetric("all-services");
  };

  return (
    <>
      <button
        ref={ref}
        className={cx("all-services-button", {
          active: isDropdownActive,
        })}
        onClick={handleClick}
      >
        <Icon
          name="ic_services-out"
          color="var(--glz-color-primary)"
          size="s"
        />
        <span className={cx("button-text")}>{strings.allServices}</span>
      </button>
      {isDropdownActive && (
        <OuterClickListener
          onClickOutside={header.closeDropdown}
          className={cx("dropdown-wrapper")}
        >
          <div className={cx("all-services-dropdown")}>
            <AllServices isMobile={false} />
          </div>
        </OuterClickListener>
      )}
    </>
  );
});

export default observer(AllServicesButton);
